document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            projectFilter(1);
        }
    });

    document.addEventListener('change', function(event) {
        if (event.target && event.target.matches(".js_filter_project")) {
            projectFilter(1);
        }
    });

    document.addEventListener('input', function(event) {
        if (event.target && event.target.matches(".js_filter_project")) {
            projectFilter(1);
        }
    });

    document.addEventListener('click', function(event) {
        if (event.target && event.target.matches(".paginate")) {
            projectFilter(event.target.dataset.pagination);
        }
    });

    const projectsContainer = document.querySelector('.projects-cards');
    const paginationContainer = document.querySelector('.news__pagination');

    function projectFilter(pagination) {
        let formData = new FormData(document.querySelector('.project-filter-form'));

        formData.append('action', 'filter-project');
        formData.append('pagination', pagination);
        formData.append('lang', variables.current_language);
        let params = new URLSearchParams(formData);

        fetch(urls.ajax, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: params
        }).then(response => {
            return response.json();
        }).then(response => {
            if (!response.success) {
                console.log("error");
            } else {
                projectsContainer.innerHTML = response.data.results;
                paginationContainer.innerHTML = response.data.pagination;

                const element = document.querySelector('.projects-cards');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    }
});
